import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { AlertCircleIcon } from 'lucide-react';
export function Login() {
  const {
    login
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // Hardcoded credentials for demo purposes
  const validCredentials = [{
    email: 'admin@sprinklenet.com',
    password: 'password123',
    role: 'admin'
  }, {
    email: 'employee@sprinklenet.com',
    password: 'password123',
    role: 'employee'
  }];
  const handleSubmit = e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      const user = validCredentials.find(cred => cred.email === email && cred.password === password);
      if (user) {
        login(user.role);
        if (user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/dashboard');
        }
      } else {
        setError('Invalid email or password');
      }
      setIsLoading(false);
    }, 800);
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-900 p-6" data-id="element-2017">
      <div className="max-w-md w-full" data-id="element-2018">
        <div className="text-center mb-8" data-id="element-2019">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/twFBSuq3u7jA2aNqB3fk3C/Sprinklenet_Logo_Black_with_Transparent_Background.png" alt="Sprinklenet Logo" className="h-16 mx-auto mb-4 invert" data-id="element-2020" />
          <h1 className="text-2xl font-bold text-gray-100" data-id="element-2021">Expense Tracker</h1>
          <p className="text-gray-400 mt-2" data-id="element-2022">
            Accounting Compliance Admin Portal
          </p>
        </div>
        <div className="bg-gray-800 rounded-lg shadow-md p-8 border border-gray-700" data-id="element-2023">
          {error && <div className="mb-4 p-3 bg-red-900 border border-red-700 rounded-md flex items-start" data-id="element-2024">
              <AlertCircleIcon size={18} className="text-red-300 mr-2 mt-0.5 flex-shrink-0" data-id="element-2025" />
              <p className="text-sm text-red-200" data-id="element-2026">{error}</p>
            </div>}
          <form onSubmit={handleSubmit} data-id="element-2027">
            <div className="space-y-4" data-id="element-2028">
              <Input label="Email Address" type="email" placeholder="name@company.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-2029" />
              <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-2030" />
              <div className="flex items-center justify-between" data-id="element-2031">
                <div className="flex items-center" data-id="element-2032">
                  <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 bg-gray-700 border-gray-600 rounded focus:ring-blue-500 focus:ring-offset-gray-800" data-id="element-2033" />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-300" data-id="element-2034">
                    Remember me
                  </label>
                </div>
                <button type="button" className="text-sm font-medium text-blue-400 hover:text-blue-300" data-id="element-2035">
                  Forgot password?
                </button>
              </div>
              <Button type="submit" className="w-full" disabled={isLoading} data-id="element-2036">
                {isLoading ? 'Signing in...' : 'Sign In'}
              </Button>
            </div>
          </form>
          <div className="mt-6" data-id="element-2037">
            <div className="relative" data-id="element-2038">
              <div className="absolute inset-0 flex items-center" data-id="element-2039">
                <div className="w-full border-t border-gray-700" data-id="element-2040"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-2041">
                <span className="px-2 bg-gray-800 text-gray-400" data-id="element-2042">
                  Demo Credentials
                </span>
              </div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-sm text-gray-300" data-id="element-2043">
              <div className="p-2 border border-gray-700 rounded-md bg-gray-750" data-id="element-2044">
                <p className="font-medium" data-id="element-2045">Admin:</p>
                <p className="text-xs mt-1 text-gray-400" data-id="element-2046">
                  admin@sprinklenet.com
                </p>
                <p className="text-xs text-gray-400" data-id="element-2047">password123</p>
              </div>
              <div className="p-2 border border-gray-700 rounded-md bg-gray-750" data-id="element-2048">
                <p className="font-medium" data-id="element-2049">Employee:</p>
                <p className="text-xs mt-1 text-gray-400" data-id="element-2050">
                  employee@sprinklenet.com
                </p>
                <p className="text-xs text-gray-400" data-id="element-2051">password123</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}